import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import GetUserInfo from '../components/users/getUserInfo';
import * as landingPageAction from '../actions/landingPageAction';
// { open: true, message: 'nothing', type: 'warning' };
function mapStateToProps(state) {
  return state.Chargecard;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...landingPageAction,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GetUserInfo);
